module.exports = __webpack_public_path__ + "static/media/icon_camera.233ab9bd.svg";